export default "__VITE_ASSET__CTQ_av9X__"